<template>
  <vs-row class="flex justify-center items-center">
    <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
      <div class="vx-col w-full mb-2">
        <div class="w-full flex justify-center items-center pt-4 pb-4">
          <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="card-title">Categoria</span>
            </div>
            <div class="w-full flex justify-center items-center">
              <span class="card-subtitle">Escolha um modelo de mensagem.</span>
            </div>

            <ul>
              <li>
                <vs-radio
                    vs-value="UTILITY"
                    v-model="data.category"
                >
                  <div class="flex ml-2">
                    <feather-icon class="left-0" icon="InboxIcon"></feather-icon>
                    <div class="ml-2">
                      <div class="w-full">
                        <span class="card-option flex-wrap">Transacional</span>
                      </div>
                      <div class="w-full">
                          <span class="card-option-sub">
                            Envie atualizações da conta, atualizações de pedido,
                            alertas e muito mais para compartilhar informações importantes.
                          </span>
                      </div>
                    </div>
                  </div>
                </vs-radio>
              </li>
              <li class="mt-5">
                <vs-radio
                    vs-value="MARKETING"
                    v-model="data.category"
                >
                  <div class="flex ml-2">
                    <feather-icon class="left-0" icon="SendIcon"></feather-icon>
                    <div class="ml-2">
                      <div class="w-full">
                        <span class="card-option flex-wrap">Marketing</span>
                      </div>
                      <div class="w-full">
                          <span class="card-option-sub">
                            Envie ofertas promocionais, anúncios de produtos e muito
                            mais para aumentar o reconhecimento e o engajamento.
                          </span>
                      </div>
                    </div>
                  </div>
                </vs-radio>
              </li>
              <li class="mt-5">
                <vs-radio
                    vs-value="AUTHENTICATION"
                    v-model="data.category"
                >
                  <div class="flex ml-2">
                    <feather-icon class="left-0" icon="KeyIcon"></feather-icon>
                    <div class="ml-2">
                      <div class="w-full">
                        <span class="card-option flex-wrap">Senhas descartáveis</span>
                      </div>
                      <div class="w-full">
                          <span class="card-option-sub">
                            Envie códigos para permitir que seus clientes acessem as contas deles.
                          </span>
                      </div>
                    </div>
                  </div>
                </vs-radio>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
      <div class="vx-col w-full mb-2">
        <div class="w-full flex justify-center items-center pt-4 pb-4">
          <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
            <div class="w-full flex justify-center items-center">
              <span class="card-title">Nome</span>
            </div>
            <div class="w-full flex justify-center items-center">
              <span class="card-subtitle">Dê um nome para o seu modelo de mensagem.</span>
            </div>

            <vs-input
                class="w-full"
                maxlength="512"
                v-model="data.name"
                @focusout="checkName"
                @keyup.prevent="formatSnakeCase"
                placeholder="Insira o nome do modelo de mensagem..."
            />

            <div class="w-full params-wrapper mt-5">
              <span class="card-subtitle">Caracteres: {{ data.name.length }}/512</span>
            </div>

            <vs-alert color="danger" icon="new_releases" active="true" class="mt-3 text-sm" v-show="!data.valid && data.name.length > 0">
              <p>Já existe um Modelo de Mensagem com este nome.</p>
            </vs-alert>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end align-end meta-template-message-container-width">
      <vs-button
          color="primary"
          type="filled"
          class="float-right"
          :disabled="tempBlock || !data.valid || data.name.length === 0"
          @click.prevent="nextPage"
      >
        <span>Continuar</span>
      </vs-button>
    </div>
  </vs-row>
</template>

<script>
import { formatRouteTenantPath } from '@/utils'
export default {
  name: 'meta-template-messages-wizard-configuration',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOfficial: false,
      tempBlock: true
    }
  },
  created(){
    this.$store.dispatch("instance/fetch", {user_id: this.$store.state.AppActiveUser.id}).then( response => {
      this.isOfficial = response.data.data.instances[0].is_official
      if(this.isOfficial === false){
        this.$router.push(formatRouteTenantPath('/not-authorized'))
      }
    }).catch(error => {console.error(error)});
  },
  methods: {
    async checkName(){
      this.$emit('checkName')
    },
    formatSnakeCase() {
      this.tempBlock = true
      this.data.name = this.data.name.toLowerCase()
      this.data.name = this.data.name.replaceAll(' ', '_')
      this.data.name = this.data.name.replace(/[^\w\s]/gi, '')
    },
    nextPage() {
      if (!this.data.name || !this.data.category) {
        this.$vs.notify({
          title: 'Revise os campos',
          text: 'É necessário preencher todos os campos para continuar!',
          color: 'danger'
        })
        return
      }

      this.$emit('nextPage')
    }
  },
  mounted() {
    this.$parent.$on("setValid", (data) => {
      this.tempBlock = !data;
    });
  }
}
</script>

<style lang="scss">
.meta-template-message-container-width {
  width: 70%;
}

.items-card {
  width: 70%;
  background: #fff;
  margin-top: 5px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
}

.card-title {
  font-weight: bold;
}

.card-option {
  font-weight: normal;
  font-size: .9rem;
}

.card-option-sub {
  font-weight: normal;
  font-size: .8rem;
}

.card-subtitle {
  font-size: .7rem;
  cursor: text;
  transition: all .2s ease;
  border-radius: 5px;
  padding: .7rem .7rem .7rem .5rem !important;
  color: rgba(0,0,0,.4);
}
</style>
